import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, urls } from '../../settings';
import { DelayLink } from '../../components';
import EventosList from '../../static/json/Eventos.json';

import './Eventos.scss';
import CarouselImages from '../../components/CarouselImages';
import carouselImages from '../../settings/carouselImage';

class Eventos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      eventActive: 0,
    };

    this.texts = texts;

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  changeItem = index => {
    const { eventActive } = this.state;

    if (index >= 0 && index < EventosList.length) {
      let events = EventosList[eventActive];

      this.setState({
        eventActive: index,
      });
    }
  };

  render = () => {
    const { eventActive } = this.state;
    let events = EventosList[eventActive];

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Eventos - {this.texts.title}</title>
        </Helmet>

        <div className="eventos-page-2020 eventos-page" ref="eventos">
          <div className="bg-eventos">
            <div className="container">
              <div className="titulo-e-hero">
                <div className="titulo-eventos">
                  <img src={images.eventos.icon_eventos} alt="Icone eventos" />
                  <h1>Eventos</h1>
                </div>

                <div className="eventos-hero">
                  <p>
                    Diferentemente dos anos anteriores, quando realizávamos tanto eventos presenciais como online, 2020
                    foi marcado pela realização quase que exclusivamente de eventos digitais. Apenas dois eventos
                    presenciais foram realizados em fevereiro, antes da pandemia.
                    <br />
                    <br />
                    Com o apoio de ferramentas de tecnologia, foi possível transmitir em diferentes ambientes, como
                    Workplace e YouTube, lives sobre assuntos diversos de interesse do mercado. Ao todo, foram 25 lives
                    ao longo do ano, que superaram 6,3 mil visualizações. Com a participação de dezenas de palestrantes, os
                    eventos tiveram como objetivo apresentar iniciativas, debater e tirar dúvidas de associados a
                    respeito dos assuntos que permearam a agenda do mercado de capitais e da indústria de fundos durante
                    2020.
                    <br />
                    <br />
                    Nem o nosso tradicional Congresso Brasileiro de Mercado de Capitais ficou de fora. Transferido do
                    primeiro para o segundo semestre, o evento foi 100% online.
                  </p>
                  <img src={images.eventos.img_hero} alt="Homem" />
                </div>
              </div>
            </div>
          </div>

          <div className="compromissos-area-container">
            <section className="compromissos-area">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <Fade bottom>
                      <div className="congresso_header">
                        <h2>{events[0].topic}</h2>

                        <div className="congresso_header__nav">
                          <div
                            className={`c__nav__button c__nav__button--prev ${eventActive <= 0 ? 'disabled' : ''}`}
                            onClick={() => this.changeItem(eventActive - 1)}
                          ></div>
                          <div className="c__nav__status">
                            <b>{eventActive + 1}</b>/{EventosList.length}
                          </div>
                          <div
                            className={`c__nav__button c__nav__button--next ${
                              eventActive + 1 > EventosList.length - 1 ? 'disabled' : ''
                            }`}
                            onClick={() => this.changeItem(eventActive + 1)}
                          ></div>
                        </div>
                      </div>
                    </Fade>

                    <Fade bottom>
                      <div className="congresso_body">
                        <div className="congresso_body__content">
                          {events.map((item, index) => {
                            return (
                              <div
                                className={`congresso_body__content__item congresso_body__content__item--${eventActive} ${
                                  item.autoHeight ? `congresso_body__content__item--auto-height` : ``
                                }`}
                                key={index}
                              >
                                {item.Congresso && (
                                  <div className="pagina-congresso">
                                    <h3 className="title">{renderHTML(item.title)}</h3>
                                    <div className="congresso-conteudo">
                                      <p>{renderHTML(item.text)}</p>
                                      <img src={images.eventos.divisor_congresso} alt="Divisor" />
                                      <div className="congresso-lista">
                                        <p>Principais números:</p>
                                        <ul>
                                          <li>+ de 9 mil inscritos</li>
                                          <li>+ de mil pessoas assistindo ao vivo diariamente</li>
                                          <li>+ de 55 mil acessos à plataforma do evento</li>
                                          <li>8,1 foi a nota média de satisfação dos participantes</li>
                                          <li>+ de 10 mil interações nas redes sociais</li>
                                          <li>146 posts nas redes sociais (incluindo Workplace)</li>
                                          <li>94 matérias na imprensa</li>
                                        </ul>
                                      </div>
                                    </div>

                                    <div className="video-footer">
                                      <iframe
                                        width="100%"
                                        height="100%"
                                        src="https://www.youtube.com/embed/DxhZG_VBw2Q"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                      ></iframe>
                                    </div>
                                  </div>
                                )}

                                {item.SemanaAmbimaLavagemDeDinheiro && (
                                  <div className="pagina-semana-ambima-prevencao">
                                    <div className="pagina-semana-ambima">
                                      <div>
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                        <p>
                                          Cinco encontros para debater e tirar dúvidas com CVM, Banco
                                          Central e BSM (Supervisão de Mercados da B3) sobre as novas regras
                                          de prevenção à lavagem de dinheiro e ao financiamento do terrorismo. Nossos
                                          associados conversaram com as principais autoridades do mercado sobre
                                          a Instrução CVM 617 e a Circular 3.978. Os bate-papos foram:
                                        </p>
                                      </div>
                                      <div className="pagina-semana-ambima-conteudo">
                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>CVM e o uso da abordagem baseada em risco</b>
                                              </p>
                                              <p>28 de setembro | 607 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=UeJ48W3GoAg" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Norma do BC e avaliação de risco pelas instituições</b>
                                              </p>
                                              <p>29 de setembro | 342 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=odCvsX_pYys" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>O olhar da BSM sobre as novas regras</b>
                                              </p>
                                              <p>30 de setembro | 395 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=w_1OFjWxh6s" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>
                                        </div>

                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Impactos na Lei do Sigilo Bancário e na LGPD</b>
                                              </p>
                                              <p>1º de outubro | 292 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=bP0V4tWZVYw" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>As boas práticas da ANBIMA</b>
                                              </p>
                                              <p>2 de outubro | 246 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=P25qao18dq8" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="footer-images">
                                      <img
                                        className="footer-images-01"
                                        src={images.eventos.divisor_semana_ambima}
                                        alt="Divisor"
                                      />
                                      <CarouselImages arrImagem={carouselImages.SemanaAmbimaLavagemDeDinheiro} />
                                    </div>
                                  </div>
                                )}

                                {item.NovaRealidadeDaIndustriaDeFundos && (
                                  <div className="pagina-semana-ambima-prevencao">
                                    <div className="pagina-semana-ambima">
                                      <div>
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                        <p>
                                          Quatro bate-papos para discutir as mudanças e os desafios impostos pela
                                          pandemia à indústria de fundos. Entre os convidados, recebemos diretores da
                                          Associação e experts do mercado. Os debates foram:
                                        </p>
                                      </div>
                                      <div className="pagina-semana-ambima-conteudo">
                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Efeitos do home office nas assets</b>
                                              </p>
                                              <p>21 de julho | 238 visualizações</p>
                                              {/* <a href="#" target="_blank">
                                                Veja como foi
                                              </a> */}
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Desafios da volta ao escritório</b>
                                              </p>
                                              <p>28 de julho | 216 visualizações</p>
                                              {/* <a href="#" target="_blank">
                                                Veja como foi
                                              </a> */}
                                            </div>
                                          </div>
                                        </div>

                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Segurança cibernética em tempos de pandemia</b>
                                              </p>
                                              <p>4 de agosto | 287 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=OUG-yaNHKhI" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Aprendizados e lições na crise</b>
                                              </p>
                                              <p>11 de agosto | 360 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=taQT3TslUoA" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="footer-images">
                                      <img
                                        className="footer-images-01"
                                        src={images.eventos.divisor_semana_ambima}
                                        alt="Divisor"
                                      />
                                      <CarouselImages arrImagem={carouselImages.NovaRealidadeDaIndustriaDeFundos} />
                                    </div>
                                  </div>
                                )}

                                {item.serieFalaCvm && (
                                  <div className="pagina-semana-ambima-prevencao">
                                    <div className="pagina-semana-ambima">
                                      <div>
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                        <p>
                                          Convidamos o regulador para debater temas em alta no mercado e tirar dúvidas
                                          dos associados. Foram três bate-papos com a CVM: discutimos a nova regulação
                                          de fundos proposta pela autarquia; falamos sobre a atuação dos influenciadores
                                          digitais e a recomendação de investimentos; e a atuação da CVM na pandemia. As
                                          lives foram:
                                        </p>
                                      </div>
                                      <div className="pagina-semana-ambima-conteudo">
                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Atuação da CVM na pandemia</b>
                                              </p>
                                              <p>24 de abril | 180 visualizações</p>
                                              {/* <a href="!#" target="_blank">
                                                Veja como foi
                                              </a> */}
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Influenciadores digitais e recomendação de investimentos</b>
                                              </p>
                                              <p>19 de novembro | 170 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=XmZXT3T_a1Q" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>
                                        </div>

                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Nova regulação de fundos</b>
                                              </p>
                                              <p>16 de dezembro | 509 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=pIoXG1MTNqk" target="_blank">
                                                Veja como foi
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="footer-images">
                                      <img
                                        className="footer-images-01"
                                        src={images.eventos.divisor_semana_ambima}
                                        alt="Divisor"
                                      />
                                      <CarouselImages arrImagem={carouselImages.serieFalaCvm} />
                                    </div>
                                  </div>
                                )}

                                {item.temasDiversosUm && (
                                  <div className="pagina-semana-ambima-prevencao">
                                    <div className="pagina-semana-ambima">
                                      <div>
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                      </div>
                                      <div className="pagina-semana-ambima-conteudo">
                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Reações da economia à Covid-19 e previsões para o ano</b>
                                              </p>
                                              <p>5 de maio | 125 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=EYU9fE-bbK0" target="_blank">
                                                Veja como foi
                                              </a>
                                              <p className="texto-link">
                                                Debate do Grupo Consultivo Macroeconômico sobre as <br />
                                                reações da economia à pandemia e as projeções para os <br />
                                                principais indicadores dadas as incertezas que o país tinha <br />
                                                pela frente.
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>BNDES oferece oportunidade para fundos imobiliários</b>
                                              </p>
                                              <p>16 de setembro | 326 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=yN324neFr8w" target="_blank">
                                                Veja como foi
                                              </a>
                                              <p className="texto-link">
                                                Conversa com representantes do banco de fomento <br />
                                                sobre as oportunidades para gestores de <br />
                                                fundos imobiliários em projetos de desestatização de <br />
                                                imóveis públicos (repasse das propriedades para a <br />
                                                iniciativa privada).
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="footer-images">
                                      <img
                                        className="footer-images-01"
                                        src={images.eventos.divisor_semana_ambima}
                                        alt="Divisor"
                                      />
                                      <CarouselImages arrImagem={carouselImages.temasDiversosUm} />
                                    </div>
                                  </div>
                                )}

                                {item.temasDiversosDois && (
                                  <div className="pagina-semana-ambima-prevencao">
                                    <div className="pagina-semana-ambima">
                                      <div>
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                      </div>
                                      <div className="pagina-semana-ambima-conteudo">
                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Regulação das companhias securitizadoras</b>
                                              </p>
                                              <p>8 de outubro | 194 visualizações</p>
                                              {/* <a href="#" target="_blank">
                                                Veja como foi
                                              </a> */}
                                              <p className="texto-link">
                                                As novas regras da CVM para as securitizadoras de <br />
                                                direitos creditórios pautaram o encontro. A proposta <br />
                                                de marco regulatório para a atividade era uma das <br />
                                                prioridades da Associação em 2020 e um dos <br />
                                                assuntos com nossa relatoria na IMK (Iniciativa de <br />
                                                Mercado de Capitais).
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>
                                                  Guias ANBIMA: padronização de debêntures e <br />
                                                  formador de mercado
                                                </b>
                                              </p>
                                              <p>14 de outubro | 504 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=qzoeJRTvSVY" target="_blank">
                                                Veja como foi
                                              </a>
                                              <p className="texto-link">
                                                Debate sobre a adoção de dois dos nossos guias de <br />
                                                melhores práticas, um voltado para a atuação dos <br />
                                                formadores de mercado e outro para auxiliar as <br />
                                                instituições na estruturação de ofertas públicas de <br />
                                                debêntures.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="footer-images">
                                      <img
                                        className="footer-images-01"
                                        src={images.eventos.divisor_semana_ambima}
                                        alt="Divisor"
                                      />
                                      <CarouselImages arrImagem={carouselImages.temasDiversosDois} />
                                    </div>
                                  </div>
                                )}

                                {item.temasDiversosTres && (
                                  <div className="pagina-semana-ambima-prevencao">
                                    <div className="pagina-semana-ambima">
                                      <div>
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                      </div>
                                      <div className="pagina-semana-ambima-conteudo">
                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>
                                                  Tira-dúvidas: novas regras de gestão de <br />
                                                  carteiras administradas{' '}
                                                </b>
                                              </p>
                                              <p>19 de outubro | 244 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=iKhyq6P1QMM" target="_blank">
                                                Veja como foi
                                              </a>
                                              <p className="texto-link">
                                                Conversa para esclarecer dúvidas dos associados <br />
                                                sobre as novas regras que entraram para a <br />
                                                autorregulação sobre a gestão de carteiras <br />
                                                administradas.
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>
                                                  Insights 2021: a transformação no trabalho <br />e os ganhos para o
                                                  mercado
                                                </b>
                                              </p>
                                              <p>8 de dezembro | 99 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=7vGG3MWoVcE" target="_blank">
                                                Veja como foi
                                              </a>
                                              <p className="texto-link">
                                                Um olhar para o futuro: a pandemia trouxe inúmeras <br />
                                                transformações para o mundo e para o mercado. Nessa <br />
                                                live, refletimos sobre os aprendizados e analisamos o que <br />
                                                seria tendência em 2021 e nos próximos anos.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="footer-images">
                                      <img
                                        className="footer-images-01"
                                        src={images.eventos.divisor_semana_ambima}
                                        alt="Divisor"
                                      />
                                      <CarouselImages arrImagem={carouselImages.temasDiversosTres} />
                                    </div>
                                  </div>
                                )}

                                {item.destaqueDaSemana && (
                                  <div className="pagina-semana-ambima-prevencao">
                                    <div className="pagina-semana-ambima">
                                      <div>
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                        <p>
                                          A quantidade e a velocidade das mudanças que se empunham ao mercado no início
                                          da pandemia precisavam ser acompanhadas de perto. Por isso, desenvolvemos uma
                                          série de lives semanais para conversar com os associados sobre temas em alta
                                          e, principalmente, tirar dúvidas em um momento tão conturbado.
                                        </p>
                                      </div>
                                      <div className="pagina-semana-ambima-conteudo">
                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>
                                                  CGA: flexibilização de regras para contratação de <br /> profissionais
                                                  não certificados
                                                </b>
                                              </p>
                                              <p>14 de maio | 85 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=qR7dlYQ_Op8" target="_blank">
                                                Veja como foi
                                              </a>
                                              <p className="texto-link">
                                                Conversa sobre a flexibilização das obrigações dos <br />
                                                profissionais terem CGA para atuar com gestão durante <br />
                                                a suspensão dos exames em razão da pandemia <br />
                                                em 2020.
                                              </p>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Especial CNF</b>
                                              </p>
                                              <p>2 de julho | 154 visualizações</p>
                                              {/* <a href="#" target="_blank">
                                                Veja como foi
                                              </a> */}
                                              <p className="texto-link">
                                                Entendemos como a CNF atua na defesa dos interesses <br />
                                                dos nossos mercados frente aos três poderes <br />
                                                (Legislativo, Executivo e Judiciário) e falamos sobre o <br />
                                                cenário político brasileiro em meio à crise. <br />
                                              </p>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Prioridades da supervisão na distribuição</b>
                                              </p>
                                              <p>9 de julho | 182 visualizações </p>

                                              <p className="texto-link">
                                                Bate-papo sobre o que estava no radar da supervisão <br />
                                                da ANBIMA em 2020, especialmente em relação à <br />
                                                distribuição de produtos de investimentos.
                                              </p>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>
                                                  Autorregulação nos mercados organizados de <br /> bolsa de valores,
                                                  balcão e infraestrutura
                                                </b>
                                              </p>
                                              <p>23 de julho | 152 visualizações </p>

                                              <p className="texto-link">
                                                Conversa sobre nossas propostas à CVM na <br />
                                                audiência que prevê a criação de um <br />
                                                autorregulador único para <br />
                                                as atividades de bolsas e infraestruturas de <br />
                                                mercado no Brasil.
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        <div>
                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Raio X do Investidor Brasileiro</b>
                                              </p>
                                              <p>20 de agosto | 131 visualizações </p>

                                              <p className="texto-link">
                                                Bate-papo sobre o que motiva as pessoas a <br />
                                                investir e onde elas aplicam o dinheiro, com <br />
                                                base nos dados da pesquisa Raio X <br />
                                                do Investidor, realizada anualmente.
                                              </p>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Portabilidade de investimentos</b>
                                              </p>
                                              <p>3 de setembro | 173 visualizações</p>
                                              <a href="https://www.youtube.com/watch?v=nFYsIGSyInU" target="_blank">
                                                Veja como foi
                                              </a>
                                              <p className="texto-link">
                                                Foram apresentadas as novas regras de portabilidade, que <br />
                                                estavam em audiência pública e entraram para o Código <br />
                                                de Distribuição em 2020.
                                              </p>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img src={images.eventos.icon_list} alt="Icone lista" />
                                            <div>
                                              <p>
                                                <b>Nova certificação para gestores de recursos</b>
                                              </p>
                                              <p>16 de outubro | 160 visualizações</p>

                                              <p className="texto-link">
                                                Conversa para apresentar e tirar dúvidas sobre as três <br />
                                                novas certificações que substituíram o antigo modelo da CGA.
                                              </p>
                                            </div>
                                          </div>

                                          <div className="pagina-semana-ambima-imagem-e-texto">
                                            <img
                                              className="img-destaque-da-semana"
                                              src={images.eventos.computador_destaque_da_semana}
                                              alt="Computador"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="footer-images">
                                      <img
                                        className="footer-images-01"
                                        src={images.eventos.divisor_semana_ambima}
                                        alt="Divisor"
                                      />
                                      <CarouselImages arrImagem={carouselImages.destaqueDaSemana} />
                                    </div>
                                  </div>
                                )}

                                {item.Webinar && (
                                  <div className="pagina-webnar">
                                    <div className="pagina-webnar-conteudo">
                                      <div className="pagina-webnar-texto">
                                        <h3 className="title">{renderHTML(item.title)}</h3>
                                        <h4 className="subtitle">{renderHTML(item.subtitle)}</h4>
                                        <p>{renderHTML(item.text)}</p>
                                      </div>
                                      <img
                                        className="img-webnar-desk"
                                        src={`${urls.assets}img/eventos/webnarImage.png`}
                                        alt="Imagem webnar"
                                      />
                                    </div>

                                    <div className="video-footer">
                                      <iframe
                                        width="100%"
                                        height="100%"
                                        src="https://www.youtube.com/embed/SYkQEj93vwY"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                      ></iframe>
                                    </div>
                                  </div>
                                )}

                                {item.AlmocoComImprensa && (
                                  <div className="pagina-webnar">
                                    <div className="pagina-webnar-conteudo">
                                      <div className="pagina-webnar-texto">
                                        <h3 className="title title-imprensa">{renderHTML(item.title)}</h3>
                                        <h4 className="subtitle">{renderHTML(item.subtitle)}</h4>
                                        <p>{renderHTML(item.text)}</p>
                                      </div>
                                      <img
                                        src={`${urls.assets}img/eventos/almoco_com_imprensa_01.png`}
                                        alt="Imagem webnar"
                                      />
                                    </div>
                                    <div className="pagina-webnar-footer-img">
                                      <img
                                        src={`${urls.assets}img/eventos/almoco_com_imprensa_02.png`}
                                        alt="Imagem webnar"
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <section className="perfil-associados-area page--green">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--blue box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-12 col--text eventos-footer-2020">
                            <h4>Veja o que fizemos em 2020</h4>
                            <DelayLink
                              to="/estrategias/nosso-ano"
                              className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Eventos };
